export enum DeviceStatus {
  online='ONLINE',
  offline='OFFLINE',
  error='ERROR'
}
